module.exports = __webpack_public_path__ + "static/pic09.e1b5f8a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic09.jpg
// module id = 134
// module chunks = 65868693374900 89684000601253